module.exports = __webpack_public_path__ + "img/ru-flag.94512440.svg";